import moment from 'moment'
import { formatRelativeValue } from 'i18n/format'

/**
 * "today", "3 days ago", "2 months ago" for the word panel's "Last seen", in the interface
 * language. The server sends `last_seen` as English text (the shipped apps show it) and
 * `last_seen_at` as the raw time; this formats the time with the server's own rules (under two
 * days is "today", then whole days, months, years) and falls back to the text when the time is
 * missing or unreadable.
 */
export const lastSeenLabel = (lastSeenAt: unknown, fallback: unknown, now: Date = new Date()): string => {
  const fallbackText = typeof fallback === 'string' ? fallback : ''
  if (typeof lastSeenAt !== 'string' || !lastSeenAt) return fallbackText
  const seen = moment(lastSeenAt)
  if (!seen.isValid()) return fallbackText
  const end = moment(now)
  const years = end.diff(seen, 'years')
  if (years >= 1) return formatRelativeValue(-years, 'year', { numeric: 'always' })
  const months = end.diff(seen, 'months')
  if (months >= 1) return formatRelativeValue(-months, 'month', { numeric: 'always' })
  const days = end.diff(seen, 'days')
  return days > 1 ? formatRelativeValue(-days, 'day', { numeric: 'always' }) : formatRelativeValue(0, 'day')
}
